export enum EModalMode {
    FULL_SCREEN = 'FULL_SCREEN', // Takes the full screen
    MAX_SIZE = 'MAX_SIZE', // Takes the full screen on mobile and leaves a margin on desktop
    FIT_CONTENT = 'FIT_CONTENT' // Fits the content
}